<template>
    <div class="ap-table-cell">
        <slot></slot>
    </div>
</template>
